import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URLS } from '../../constants/api-urls/api-urls';
import { PlatformRegionService } from '../../../service/shared/platform-region.service';
import { skipSpinnerOptions } from '../../core/services/http-options.utils';
import { RoleplayFeedbackUserEvalCreate, RoleplayFeedbackUserEvalMatch, RoleplayFeedbackUserEvalMatchResponse, RoleplayFeedbackUserEvalResponse, RoleplayFeedbackUserEvalUpdate } from '../../../model/roleplay/roleplay-feedback-user-eval.model';

@Injectable({
  providedIn: 'root'
})
export class RoleplayFeedbackUserEvalApiService {

  constructor(
    private http: HttpClient,
    private platformRegionService: PlatformRegionService
  ) { }

  create(payload: RoleplayFeedbackUserEvalCreate): Observable<RoleplayFeedbackUserEvalResponse> {
    return this.http.post<RoleplayFeedbackUserEvalResponse>(API_URLS.ROLEPLAY.FEEDBACK_USER_EVAL.CREATE, payload, skipSpinnerOptions());
  }

  update(payload: RoleplayFeedbackUserEvalUpdate): Observable<RoleplayFeedbackUserEvalResponse> {
    return this.http.patch<RoleplayFeedbackUserEvalResponse>(API_URLS.ROLEPLAY.FEEDBACK_USER_EVAL.UPDATE, payload, skipSpinnerOptions());
  }

  getList(): Observable<RoleplayFeedbackUserEvalResponse[]> {
    const bu = this.platformRegionService.selected_platform_code;
    const region = this.platformRegionService.selected_region_code;
    return this.http.get<RoleplayFeedbackUserEvalResponse[]>(API_URLS.ROLEPLAY.FEEDBACK_USER_EVAL.LIST(bu, region), skipSpinnerOptions());
  }

  match(payload: RoleplayFeedbackUserEvalMatch): Observable<RoleplayFeedbackUserEvalMatchResponse> {
    return this.http.post<RoleplayFeedbackUserEvalMatchResponse>(API_URLS.ROLEPLAY.FEEDBACK_USER_EVAL.MATCH, payload, skipSpinnerOptions());
  }
}
